import { useTranslation } from 'react-i18next'

import { Container } from 'src/components/Container/Container'
import { Headline } from 'src/components/Headline/Headline'
import { SimilarProductCard } from 'src/components/ProductCard/SimilarProductCard'

import styles from './SimilarProducts.module.scss'

import type { Product } from 'src/data/graphql-generated'

interface SimilarProductsProps {
  products: Product[]
  productType: Product['productType']
}

const SIMILAR_PRODUCTS_LIMIT = 3

export const SimilarProducts = ({ products, productType }: SimilarProductsProps) => {
  const { t } = useTranslation()

  if (products.length === 0) return null

  const similarProductsTitle = t(`pdp.similarProducts.title.${productType === 'coffee' ? 'coffee' : 'gear'}`)

  return (
    <Container>
      <Headline variant="h2" className={styles.similarProductsTitle}>
        {similarProductsTitle}
      </Headline>
      <div className={styles.cardContainer}>
        {products?.slice(0, SIMILAR_PRODUCTS_LIMIT).map((product) => (
          <SimilarProductCard product={product} key={`similar-product-${product.id}`} />
        ))}
      </div>
    </Container>
  )
}
